@if (notifications.length) {
  <div class="position-fixed top-0 end-0 p-3 alert-notification-container">
    @for (notification of notifications; track notification) {
      <div class="alert-notification-item" [ngClass]="{
            'alert': true,
            'fade': true,
            'show': !notification.fadeOut,
            'alert-success': notification.type === 'success',
            'alert-danger': notification.type === 'error',
            'alert-warning': notification.type === 'warning'
          }">
        {{ notification.message }}
      </div>
    }
  </div>
}
